import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useOnboardingStore } from "../../stores/onboardingStore";
import { ChatMessage } from "../chat/ChatMessage";
import { ChatInput } from "../chat/ChatInput";

export function OnboardingChat() {
  const { messages, isStreaming, isComplete, sendMessage, completeOnboarding } =
    useOnboardingStore();
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleComplete = async (destination: string) => {
    await completeOnboarding();
    navigate(destination);
  };

  return (
    <div className="flex-1 overflow-y-auto px-4">
      <div className="min-h-full flex flex-col justify-center py-6">
        <div className="space-y-4">
          {messages.map((msg) => (
            <ChatMessage key={msg.id} message={msg} />
          ))}
          <div ref={messagesEndRef} />
        </div>

        {/* Input or completion CTA */}
        <div className="pt-4">
          {isComplete ? (
            <div className="text-center space-y-3">
              <p className="text-sm text-gray-600">
                Connecting Strava enriches your coaching with detailed activity
                data and deeper insights — but it's completely optional, you can
                always do it later.
              </p>
              <div className="flex items-center justify-center gap-3">
                <button
                  onClick={() => handleComplete("/app/settings/integrations")}
                  className="px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors text-sm font-medium"
                >
                  Connect Strava
                </button>
                <button
                  onClick={() => handleComplete("/app/activities")}
                  className="px-4 py-2 text-gray-600 hover:text-gray-900 text-sm"
                >
                  Continue without
                </button>
              </div>
            </div>
          ) : (
            <ChatInput
              onSend={sendMessage}
              disabled={isStreaming}
              placeholder="Type your answer..."
            />
          )}
        </div>
      </div>
    </div>
  );
}
